import {ufNameMap} from 'presentation/pages/private/booking/constants';
import {formatPadStartCnpj, formatPadStartCpf} from 'presentation/utils';
import {ParseRefundProvidersProps} from './types';

export const parseRefundProviders = ({providers, councils}: ParseRefundProvidersProps) =>
	providers.map(provider => {
		const councilAcronymDescription =
			councils?.find(council => council.acronym === provider.acronym)?.description || '';

		const providerDocument = String(provider.document);
		const isCpfDocument = providerDocument.length <= 11;

		return {
			...provider,
			councilAcronym: {
				acronym: provider.acronym,
				description: councilAcronymDescription,
			},
			councilNumber: String(provider.councilNumber),
			councilState: {
				code: provider.councilState,
				state: ufNameMap[provider.councilState],
			},
			document: isCpfDocument
				? formatPadStartCpf(providerDocument)
				: formatPadStartCnpj(providerDocument),
			providerCode: String(provider.providerCode),
		};
	});
